import { useEffect, useState } from 'react';

import { CONTENT_ID } from '~/pages/Root/constants';

/**
 * Whether the page is scrolled away from the top. Desktop scrolls inside the
 * content container below the fixed header, mobile scrolls the window.
 */
export const useScrolled = (isMobile: boolean) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const target: Window | HTMLElement | null = isMobile
      ? window
      : document.getElementById(CONTENT_ID);
    if (!target) {
      return;
    }

    const update = () => {
      const offset =
        target instanceof Window ? target.scrollY : target.scrollTop;
      setScrolled(offset > 0);
    };

    update();
    target.addEventListener('scroll', update, { passive: true });

    return () => target.removeEventListener('scroll', update);
  }, [isMobile]);

  return scrolled;
};
